import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem, IconButton, Tooltip } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import { coloresEmma } from "../../../../global/js/funciones";
import { FILTRO_TODOS } from "../../services/alertasGenericasService";

const FiltrosResumen = ({
  filtroAnio,
  filtroSemestre,
  filtroPrograma,
  filtroCompetencia,
  opcionesAnio,
  opcionesSemestre,
  opcionesPrograma,
  opcionesCompetencia = [],
  onAnioChange,
  onSemestreChange,
  onProgramaChange,
  onCompetenciaChange,
  onDescargarExcel,
  deshabilitarDescarga = false,
}) => {
  const renderOpciones = (opciones, incluirTodos = true, valorActual) => {
    const items = [];
    const valores = Array.isArray(opciones) ? [...opciones] : [];
    if (incluirTodos) {
      items.push(
        <MenuItem key={FILTRO_TODOS} value={FILTRO_TODOS} style={{ fontSize: 12 }}>
          Todos
        </MenuItem>
      );
    }
    valores.forEach((val) => {
      if (val === FILTRO_TODOS) return;
      items.push(
        <MenuItem key={val} value={val} style={{ fontSize: 12 }}>
          {val}
        </MenuItem>
      );
    });
    if (valorActual && valorActual !== FILTRO_TODOS && !valores.some((v) => v === valorActual)) {
      items.push(
        <MenuItem key={valorActual} value={valorActual} style={{ fontSize: 12 }}>
          {valorActual}
        </MenuItem>
      );
    }
    return items;
  };

  return (
    <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
      <FormControl variant="outlined" size="small" style={{ width: 100, minHeight: 0, marginRight: 4 }}>
        <InputLabel style={{ fontSize: 12 }}>Año</InputLabel>
        <Select
          value={filtroAnio || FILTRO_TODOS}
          onChange={(e) => onAnioChange(e.target.value)}
          label="Año"
          style={{ height: 32, fontSize: 12 }}
        >
          {renderOpciones(opcionesAnio)}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" style={{ width: 108, minHeight: 0, marginRight: 6 }}>
        <InputLabel style={{ fontSize: 12 }}>Semestre</InputLabel>
        <Select
          value={filtroSemestre || FILTRO_TODOS}
          onChange={(e) => onSemestreChange(e.target.value)}
          label="Semestre"
          style={{ height: 32, fontSize: 12 }}
        >
          {renderOpciones(opcionesSemestre)}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" style={{ minWidth: 160, maxWidth: 220, marginRight: 4 }}>
        <InputLabel style={{ fontSize: 12 }}>Competencia</InputLabel>
        <Select
          value={filtroCompetencia || "RC"}
          onChange={(e) => onCompetenciaChange(e.target.value)}
          label="Competencia"
          style={{ height: 32, fontSize: 12 }}
        >
          {opcionesCompetencia.map((item) => (
            <MenuItem key={item.codigo} value={item.codigo} style={{ fontSize: 12 }}>
              {item.nombre}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" style={{ minWidth: 220, maxWidth: 320, marginRight: 4 }}>
        <InputLabel style={{ fontSize: 12 }}>Programa</InputLabel>
        <Select
          value={filtroPrograma || FILTRO_TODOS}
          onChange={(e) => onProgramaChange(e.target.value)}
          label="Programa"
          style={{ height: 32, fontSize: 12 }}
        >
          {renderOpciones(opcionesPrograma, true, filtroPrograma)}
        </Select>
      </FormControl>
      <Tooltip title="Descargar Excel">
        <span>
          <IconButton
            size="small"
            onClick={onDescargarExcel}
            disabled={deshabilitarDescarga}
            style={{ marginLeft: 2 }}
            aria-label="Descargar resumen en Excel"
          >
            <GetAppIcon style={{ color: coloresEmma.primarycolor }} />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default FiltrosResumen;
